__turbopack_context__.v({
  "addAttachment": "EvTIpa_addAttachment",
  "attached": "EvTIpa_attached",
  "icon": "EvTIpa_icon",
  "input": "EvTIpa_input",
  "inputTrigger": "EvTIpa_inputTrigger",
});
